import { Button } from '@mantine/core';
import { useUnit } from 'effector-react';
import { useTranslation } from 'react-i18next';
import { ExportReportShiftsModel } from '../../model';

export const createExportReportShifts = (model: ExportReportShiftsModel) => {
	const ExportReportShiftButton = () => {
		const { t } = useTranslation();
		const exportButtonClicked = useUnit(model.exportButtonClicked);

		return <Button onClick={exportButtonClicked}>{t('export-report-shifts.export-excel')}</Button>;
	};

	return ExportReportShiftButton;
};
